import { React, useState, useEffect } from "react";
import { Button, Form, Input, Switch, Col, Row, Tooltip, Checkbox } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { GlobalSet, Styled } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import trusted from "../../../Assets/Icons/trusted.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import {
  addNewGrade,
  setOrderType,
  getMachineGradeSelectForConfig,
  deleteGrade,
  deleteQuality,
} from "../../../Services/settingsServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import styled from "styled-components";
import { capital_letter } from "../../../Utils/helper/helper";

const ProductParam = styled.div`
  .ant-checkbox-wrapper {
    display: flex;
    line-height: 30px;
  }
  .ant-checkbox-disabled + span {
    color: #000000d9;
  }
`;

const EditDeleteGrade = (props) => {
  const productParameters = [
    {
      label: "GSM",
      value: "gsm",
      disabled: true,
    },
    {
      label: "Bulk",
      value: "bulk",
      disabled: true,
    },
    {
      label: "BF",
      value: "burst_factor",
      disabled: props.grade.product ? false : true,
    },
    {
      label: "Moisture",
      value: "moisture",
      disabled: props.grade.product ? false : true,
    },
  ];
  const product = props.grade.product;
  const [isActiveOpen, setActiveOpen] = useState(false);
  // const [switchTooltip, setSwitchTooltip] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [grade, setGrade] = useState(props.grade);
  const [modalPopUpData, setModalPopUpData] = useState();
  const [modifiedQuality, setModifiedQuality] = useState();
  const [addQualityAlert, setAddQualityAlert] = useState(false);
  const [deleteQualityAlert, setDeleteQualityAlert] = useState(false);
  const [addDeleteResponse, setAddDeleteResponse] = useState();
  const [form] = Form.useForm();
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [selectedParam, setSelectedParams] = useState({
    gsm: product?.gsm,
    burst_factor: product?.burst_factor,
    moisture: product?.moisture,
    bulk: product?.bulk,
  });
  const [defaultParam, setDefaultParam] = useState([]);
  const [isProductParamChange, setIsProductParamChange] = useState(false);
  const [editParamAlert, setEditParamAlert] = useState(false);
  const [editParamResp, setEditParamResp] = useState();
  const [qualityErr, setQualityErr] = useState(false);

  useEffect(() => {
    let value = [];
    if (product?.gsm) value.push("gsm");
    if (product?.burst_factor) value.push("burst_factor");
    if (product?.moisture) value.push("moisture");
    if (product?.bulk) value.push("bulk");
    if (!value.length) value = [...["gsm", "bulk", "burst_factor"]];
    setDefaultParam(value);
  }, []);

  const updatedGrade = async () => {
    const resp = await getMachineGradeSelectForConfig();
    if (!resp.error) {
      const requiredGrade = resp.data.data.settings.grades.filter((item) => {
        return item.name === grade.name;
      });
      setGrade(requiredGrade[0]);
    }
  };

  const handleSwitchChangeQuality = (checked, quality) => {
    if (checked === false) {
      setModalPopUpData({
        title: "Disable quality?",
        content:
          "A new product cannot be created for this quality. Are you sure you want to continue?",
        image: warning,
        key: "quality",
        action: "modify",
        value: checked,
        data: quality,
      });
      modalShow();
    } else {
      setModalPopUpData({
        title: "Enable quality?",
        content:
          "New products can be created for the enabled qualities. Are you sure you want to continue?",
        image: trusted,
        key: "quality",
        action: "modify",
        value: checked,
        data: quality,
      });
      modalShow();
    }
  };

  const handleDeleteQuality = (quality) => {
    setModalPopUpData({
      title: "Delete quality?",
      content:
        "You will not be able to recover this quality once deleted. Are you sure you want to continue?",
      image: warning,
      key: "quality",
      action: "delete",
      data: quality,
    });
    modalShow();
  };

  const handleDeleteGrade = () => {
    setModalPopUpData({
      title: "Delete grade?",
      content:
        "A grade once deleted cannot be recovered. Are you sure you want to continue?",
      image: warning,
      key: "grade",
      action: "delete",
      data: grade,
    });
    modalShow();
  };

  const onProductParameterChange = (e) => {
    let paramObject = {
      gsm: true,
      burst_factor: false,
      moisture: false,
      bulk: true,
    };
    for (let index = 0; index < e.length; index++) {
      const param = e[index];
      paramObject[`${param}`] = true;
    }
    setSelectedParams(paramObject);
    setIsProductParamChange(true);
  };

  const showAlert = (setAlert) => {
    setAlert(true);
    setTimeout(() => setAlert(false), 2000);
  };

  const modalShow = () => {
    setIsVisibleModal(true);
  };

  const modalClose = () => {
    setIsVisibleModal(false);
  };

  const modalConfirm = async () => {
    // console.log("selection", modalPopUpData);
    if (modalPopUpData.action === "modify")
      changeQualityState(modalPopUpData.value, modalPopUpData.data);
    else if (modalPopUpData.action === "delete")
      if (modalPopUpData.key === "quality")
        deleteQualityHandler(modalPopUpData.data);
      else if (modalPopUpData.key === "grade") deleteGradeHandler();
    setIsVisibleModal(false);
    setModalPopUpData();
  };

  const toggleClass = () => {
    setActiveOpen(!isActiveOpen);
  };

  // const editGradeName = async (e) => {
  //   const requestBody = {
  //     grade: grade.name,
  //     name: e.target.value,
  //     value: true,
  //   };
  //   try {
  //     const response = await setOrderType(requestBody);
  //     if (!response.error) {
  //       setGrade({ ...grade, name: e.target.value });
  //       props.updateList();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const editGradeAlias = async (e) => {
  //   const requestBody = {
  //     grade: grade.name,
  //     alias: e.target.value,
  //     value: true,
  //   };
  //   try {
  //     const response = await setOrderType(requestBody);
  //     if (!response.error) {
  //       setGrade({ ...grade, alias: e.target.value });
  //       props.updateList();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const addQualityHandler = async (e) => {
    let qualityName = capital_letter(e.quality_name.trim());
    const requestBody = {
      grade: grade.name,
      quality: {
        // name: e.quality_name,
        name: qualityName.trim(),
        description: e.quality_description ? e.quality_description : "",
        value: true,
      },
    };
    try {
      const response = await addNewGrade(requestBody);
      if (!response.error) {
        let tempArray = grade.qualities || [];
        tempArray?.push({
          name: e.quality_name.trim(),
          description: e.quality_description,
          value: true,
        });
        setGrade({ ...grade, qualities: tempArray });
        toggleClass();
        form.setFieldsValue({
          quality_name: "",
          quality_description: "",
        });
        setAddDeleteResponse(response);
        setModifiedQuality(capital_letter(e.quality_name.trim()));
        showAlert(setAddQualityAlert);
        props.updateList();
      }
    } catch (error) {
      // console.log(error);
      // setAddDeleteResponse(
      //   error.response.data ? error.response.data : "Error while saving quality"
      // );
      // showAlert(setAddQualityAlert);

      if(error?.response?.status == 500){
          let res = {
            error: true,
            msg: "Something went wrong. Please try again"
          }
          setEditParamResp(res);
      } else{
        let res = {
            error: true,
            msg: error?.response?.data?.msg
        }
        setEditParamResp(res);
      }

      setEditParamAlert(true);
      setTimeout(() => {
        setEditParamAlert(false);
      }, 2000);

    }
    // }
  };

  const changeQualityState = async (checked, currentQuality) => {
    const requestBody = {
      grade: grade.name,
      quality: currentQuality.name,
      value: checked,
    };
    await setOrderType(requestBody)
      .then((response) => {
        updatedGrade();
        props.updateList();
      })
      .catch((error) => {
        console.log("error in setting order type:", error);
        if(error?.response?.status == 500){
          let res = {
            error: true,
            msg: "Something went wrong. Please try again"
          }
          setEditParamResp(res);
        } else{
          let res = {
              error: true,
              msg: error?.response?.data?.msg
          }
          setEditParamResp(res);
        }

        setEditParamAlert(true);
        setTimeout(() => {
          setEditParamAlert(false);
        }, 2000);
        });
  };

  const deleteQualityHandler = async (currentQuality) => {
    try {
      const response = await deleteQuality(
        grade.name,
        capital_letter(currentQuality.name)
      );
      if (!response.error) {
        updatedGrade();
        props.updateList();
        setAddDeleteResponse(response);
        setModifiedQuality(capital_letter(currentQuality.name));
        showAlert(setDeleteQualityAlert);
        //props.onClose();
      }
    } catch (error) {
      console.log(error);
      setAddDeleteResponse(error.response.data);
      showAlert(setDeleteQualityAlert);
    }
  };

  const deleteGradeHandler = async () => {
    try {
      const response = await deleteGrade(grade.name);
      if (!response.error) {
        props.updateList();
        props.onCloseGrade(response);
      }
    } catch (error) {
      console.log(error);
      props.onCloseGrade(error.response.data);
    }
  };

  const onSaveProductParams = async () => {
    const requestBody = {
      grade: grade.name,
      product: selectedParam,
      value: props.grade.value,
    };
    await setOrderType(requestBody)
      .then((response) => {
        setEditParamResp(response);
        setEditParamAlert(true);
        setTimeout(() => {
          setEditParamAlert(false);
          props.onClose();
        }, 3000);
      })
      .catch((error) => {
        // setEditParamResp(error.response.data);
        // setEditParamAlert(true);
        // setTimeout(() => {
        //   setEditParamAlert(false);
        // }, 3000);
        // console.log("error in setting order type:", error);

        if(error?.response?.status == 500){
          let res = {
            error: true,
            msg: "Something went wrong. Please try again"
          }
          setEditParamResp(res);
      } else{
        let res = {
            error: true,
            msg: error?.response?.data?.msg
        }
        setEditParamResp(res);
      }

      setEditParamAlert(true);
      setTimeout(() => {
        setEditParamAlert(false);
      }, 2000);
      });
  };

  const onQualityChange = (event) => {
    setQualityErr(false);
    if (grade?.qualities?.length > 0) {
      grade?.qualities?.forEach((quality) => {
        if (quality.name?.toLowerCase() === event.target.value?.toLowerCase()) {
          setQualityErr(true);
        }
      });
    }
  };
  return (
    <RightDrawerSidebar
      title={`${grade.alias} Grade`}
      subtitle={grade.name}
      visible={props.visible}
      extra={[<Button>OK</Button>]}
      onClose={props.onClose}
    >
      {addQualityAlert && (
        <AlertContainer
          color={addDeleteResponse.error ? "red" : "green"}
          icon={addDeleteResponse.error ? alertRed : alertGreen}
          msg={
            addDeleteResponse.error
              ? addDeleteResponse.msg
              : `A new quality ${modifiedQuality} is added to grade ${grade.name}`
          }
        />
      )}
      {editParamAlert && (
        <AlertContainer
          color={editParamResp.error ? "red" : "green"}
          icon={editParamResp.error ? alertRed : alertGreen}
          msg={editParamResp.msg}
        />
      )}
      {deleteQualityAlert && (
        <AlertContainer
          color={addDeleteResponse.error ? "red" : "green"}
          icon={addDeleteResponse.error ? alertRed : alertGreen}
          msg={
            addDeleteResponse.error
              ? addDeleteResponse.msg
              : `Quality ${modifiedQuality} is deleted`
          }
        />
      )}
      {/* {console.log("Props", props)} */}
      {defaultParam.length ? (
        <RightDrawerContainer>
          <div className="resetPassForm removePadLeft">
            {/* {addQualityAlert && (
            <AlertContainer
              color={addDeleteResponse.error ? "red" : "green"}
              icon={addDeleteResponse.error ? alertRed : alertGreen}
              msg={
                addDeleteResponse.error
                  ? addDeleteResponse.msg
                  : `A new quality ${modifiedQuality} is added to grade ${grade.name}`
              }
            />
          )} */}
            {/* {deleteQualityAlert && (
            <AlertContainer
              color={addDeleteResponse.error ? "red" : "green"}
              icon={addDeleteResponse.error ? alertRed : alertGreen}
              msg={
                addDeleteResponse.error
                  ? addDeleteResponse.msg
                  : `Quality ${modifiedQuality} is deleted`
              }
            />
          )} */}
            <HaberForm>
              {/* <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin haberSignup"
              style={{ marginTop: "0" }}
            > */}
              <div className="drawerField" style={{ paddingTop: "0" }}>
                <div className="titleWithText">
                  <h5>Name of the grade</h5>
                  <p>The grade will be identified by this unique name</p>
                </div>
                <Form.Item
                  name="Grade Name"
                  rules={[{ required: true }]}
                  className=""
                  // initialValue={grade.name}
                >
                  <Input
                    placeholder="Enter name of the grade"
                    defaultValue={grade.name}
                    //onMouseLeave={editGradeName}
                    disabled
                  />
                </Form.Item>
              </div>

              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Grade Alias</h5>
                  <p>An alternate short name to identify this grade</p>
                </div>
                <Form.Item
                  name="Grade Alias"
                  rules={[{ required: true }]}
                  className=""
                  // initialValue={grade.alias}
                >
                  <Input
                    placeholder="Enter alias of the grade"
                    defaultValue={grade.alias}
                    //onMouseLeave={editGradeAlias}
                    disabled
                  />
                </Form.Item>
              </div>
              <div className="drawerField">
                <div className="titleWithText">
                  <h5>Product Parameters</h5>
                  <p>
                    The product parameters that apply to the products of this
                    grade{" "}
                  </p>
                </div>
                <Form.Item
                  name="product_parameters"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                  className=""
                >
                  <ProductParam>
                    <Checkbox.Group
                      options={productParameters}
                      defaultValue={defaultParam}
                      // checked={isChecked}
                      onChange={onProductParameterChange}
                      className="flexRowReverse"
                    />
                  </ProductParam>
                </Form.Item>
              </div>
              <div className="drawerField" style={{ paddingTop: "12px" }}>
                <div className="titleWithText xtraText">
                  <h3>Grade Qualities</h3>
                  <p>You can provide multiple qualities of this grade.</p>
                </div>
              </div>

              <div
                className={
                  isActiveOpen
                    ? "qualityToggled openHeight"
                    : "qualityToggled closeHeight"
                }
              >
                <GlobalSet
                  style={{ textAlign: "left", marginTop: "16px" }}
                  onClick={toggleClass}
                >
                  <Button
                    className="textTypeBtn textBtnIcon"
                    style={{ marginLeft: "0" }}
                    disabled={!userDetails.roles.global_settings.edit}
                  >
                    <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                    Add a new quality
                  </Button>
                </GlobalSet>
                <div className={isActiveOpen ? "openQuality" : "closeQuality"}>
                  <div className="drawerField" style={{ paddingTop: "0" }}>
                    <div
                      className="titleWithText dFlex"
                      style={{
                        justifyContent: "space-between",
                        margin: "10px 0 6px",
                      }}
                    >
                      <h5 style={{ alignSelf: "center" }}>Add a new quality</h5>
                      <GlobalSet
                        className="specialBtn adjCntBtn"
                        style={{ width: "calc(100% - 125px)" }}
                      >
                        <Styled styled={{ display: "flex" }}>
                          <Tooltip
                            placement="bottomRight"
                            title={"Cancel Quality"}
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                          >
                            <Button
                              className="textTypeBtn noMargin blackTxt"
                              onClick={toggleClass}
                            >
                              Cancel
                            </Button>
                          </Tooltip>
                        </Styled>
                        <Styled styled={{ display: "flex" }}>
                          <Tooltip
                            placement="bottomRight"
                            title={"Save Quality"}
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                          >
                            <Button
                              onClick={() => {
                                form.submit();
                              }}
                              className="textTypeBtn textBtnIcon"
                            >
                              <Iconmoon
                                icon="addcircle"
                                size={14}
                                color="#EA655B"
                              />
                              Save
                            </Button>
                          </Tooltip>
                        </Styled>
                      </GlobalSet>
                    </div>
                    <p className="qualityInfo It">
                      You can’t modify a quality once added. A quality can only
                      be deleted if there is no product created for that quality
                    </p>
                    <Form
                      form={form}
                      name="basic"
                      autoComplete="off"
                      className="haberLogin haberSignup"
                      style={{ marginTop: "0" }}
                      onFinish={addQualityHandler}
                    >
                      <Form.Item
                        name="quality_name"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            max: 50,
                            message: "Name can have a maximum of 50 characters",
                          },
                          {
                            validator(_, value) {
                              if (qualityErr) {
                                return Promise.reject(
                                  "Quality name must be unique"
                                );
                              } else {
                                return Promise.resolve();
                              }
                            },
                          },
                        ]}
                        className=""
                      >
                        <Input
                          placeholder="Enter name of the quality"
                          onChange={onQualityChange}
                          style={{ textTransform: "capitalize" }}
                        />
                      </Form.Item>
                      <Form.Item
                        name="quality_description"
                        rules={[
                          {
                            max: 50,
                            message:
                              "Description can have a maximum of 50 characters",
                          },
                        ]}
                        className="textareaField"
                      >
                        <Input.TextArea placeholder="Enter description of the quality" />
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>

              <DetailFields>
                <div className="groupDetailWrap qualityRow">
                  <Row gutter={[24, 24]} className="groupForm">
                    <Col span={24}>
                      {grade.qualities?.map((quality, index) => {
                        // console.log('quality', quality)
                        return (
                          <Row className="centerAlign">
                            <Col span={18}>
                              <div className="boxFieldTitle">
                                {/* <label>{capital_letter(quality.name)}</label> */}
                                <label
                                  style={{
                                    display: "block", 
                                    maxWidth: "25ch", 
                                    wordBreak: "break-word", 
                                    whiteSpace: "normal",   
                                  }}
                                >
                                  {capital_letter(quality.name)}
                                </label>

                                <p>{quality.description}</p>
                              </div>
                            </Col>
                            <Col span={6}>
                              <div className="boxFormType">
                                <GlobalSet>
                                  <Styled
                                    className="dFlex centerAlignBtn"
                                    style={{ paddingLeft: "5px" }}
                                  >
                                    <Tooltip
                                      placement="bottomRight"
                                      title={
                                        props.roles.edit
                                          ? quality.value
                                            ? "Disable quality"
                                            : "Enable quality"
                                          : quality.value
                                          ? `${quality.name} is enabled`
                                          : `${quality.name} is disabled`
                                      }
                                      getPopupContainer={(triggerNode) =>
                                        triggerNode
                                      }
                                    >
                                      <Switch
                                        // defaultChecked
                                        onChange={(e) =>
                                          handleSwitchChangeQuality(e, quality)
                                        }
                                        className="switch-new"
                                        checked={quality.value}
                                        // Disabled the toggle based on the role-control doc
                                        disabled={!props.roles.edit}
                                      />
                                    </Tooltip>
                                    {props.roles.edit && (
                                      <Tooltip
                                        placement="bottomRight"
                                        title={"Delete Quality"}
                                        getPopupContainer={(triggerNode) =>
                                          triggerNode
                                        }
                                      >
                                        <Button
                                          onClick={() =>
                                            handleDeleteQuality(quality)
                                          }
                                          // disabled={index === 0}
                                          className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                        >
                                          <Iconmoon
                                            icon="delete"
                                            size={17}
                                            color="#605E5C"
                                          />
                                        </Button>
                                      </Tooltip>
                                    )}
                                  </Styled>
                                </GlobalSet>
                              </div>
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                  </Row>
                </div>
              </DetailFields>
              {props.roles.edit && (
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      className="themeBtn"
                      onClick={onSaveProductParams}
                      disabled={!isProductParamChange}
                    >
                      <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                      Save
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="themeBtn noBg"
                      onClick={handleDeleteGrade}
                    >
                      <Iconmoon icon="delete" size={16} color="#EA655B" />
                      Delete Grade
                    </Button>
                  </Form.Item>
                </div>
              )}
              {/* </Form> */}
            </HaberForm>
          </div>
        </RightDrawerContainer>
      ) : null}
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={modalPopUpData && modalPopUpData.image} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>{modalPopUpData && modalPopUpData.title}</span>
          <p>{modalPopUpData && modalPopUpData.content}</p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
  );
};
export default EditDeleteGrade;
